﻿import axios from 'axios';
import ApplicationActions from '../actions/ApplicationActions.js';

module.exports = {
    init: function () {
        // Set default headers
        var defaultContentType = 'application/json';
        axios.defaults.headers.post['Content-Type'] = defaultContentType;
        axios.defaults.headers.put['Content-Type'] = defaultContentType;

        var _extendSessionTimeout;

        // Add a request interceptor 
        axios.interceptors.request.use(function (config) {
            // Do something before request is sent 
            return config;
        }, function (error) {
            // Do something with request error 
            return Promise.reject(error);
        });
 
        // Add a response interceptor 
        axios.interceptors.response.use(function (response) {
            // Refresh FirstNet session via iframe if we have OIN in userContext (aka has session established)
            if (window.NOA.userContext.isExisting) {
                var checkSession = document.getElementById('checkSession');
                if (checkSession) {
                    checkSession.src = checkSession.src;
                }

                ApplicationActions.extendSession(false);
                if (_extendSessionTimeout) {
                    clearTimeout(_extendSessionTimeout);
                    _extendSessionTimeout = void 0;
                }

                _extendSessionTimeout = setTimeout(function(){
                    ApplicationActions.extendSession(true);
                }, (window.NOA.configuration.sessionTimeout-5) * 60000);
            }

            return response;
        }, function (error) {
            // Do something with response error 
            return Promise.reject(error);
        });
    }
};


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./apis/HttpClient.js